export default "__VITE_ASSET__CG2wcYIX__"